import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input, Checkbox, Tabs, TabContainer } from "@gpstrackit/react-controls"
import { NotificationManager } from 'Components/Notifications'
import UnitTypeEventsList from '../../../.components/unitTypeEvents'

//Actions
import {
    clearRedux,
    eventCreateRequest,
    eventGetRequest,
    eventEditRequest,
} from 'Redux/actions';

const CreateEditEvent = (props) => {
    const { tableRef, getData } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRefEvent = useRef();

    const { openModal, loading, create, update, event, current } = useSelector(state => state.createEditEventRedux);

    const [name, setName] = useState('');
    const [color, setColor] = useState('#000000');
    const [diagnostic, setDiagnostic] = useState(false);
    const [tab, setTab] = useState(0);



    const closeModal = () => {
        setName('');
        setDiagnostic(true);
        dispatch(clearRedux("EVENT_CREATE_EDIT"))
    }

    const applyChangesEvent = () => {
        const trimmedName = name.trim();
        if (!trimmedName) {
            NotificationManager.error(
                messages['required_field'],
                messages['event_name'],
                3000
            );
            return;
        }

        let payload = {
            name: trimmedName,
            color,
            diagnostic
        }
        if (current?.id) {
            payload.id = current?.id
            dispatch(eventEditRequest(payload))
        } else dispatch(eventCreateRequest(payload))
    }

    useEffect(() => {
        if (create?.id) {
            NotificationManager.success(
                messages['event_create_success_message'],
                messages['event_create_title'],
                3000
            );
            closeModal();
            tableRef && tableRef?.current?.getData();
            dispatch(clearRedux("EVENT_CREATE_EDIT", { create: null }))
        }

        if (update) {
            NotificationManager.success(
                messages['event_edit_success_message'],
                messages['event_edit_title'],
                3000
            );
            closeModal();
            tableRef && tableRef?.current?.getData();
            getData && getData()
            dispatch(clearRedux("EVENT_CREATE_EDIT", { update: null }))
        }

        if (event) {
            setName(event?.name);
            setColor(event?.color);
            setDiagnostic(event?.diagnostic);
        }
    }, [create, update, current, event])

    useEffect(() => {
        if (openModal && current?.id) {
            dispatch(eventGetRequest(current?.id))
        }
    }, [openModal])

    return (
        <Modal
            open={openModal}
            title={current?.id ? `${messages['event_edit_title']} (${current?.name})` : messages['event_create_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    <Tabs
                        tab={tab}
                        className="create-edit-events-tabs"
                        onChange={(event) => setTab(event)}
                    >
                        <TabContainer index={0} label={messages['event_tab_general']}>
                            <Form
                                ref={formRefEvent}
                                onValidSubmit={() => applyChangesEvent()}
                            >
                                <div style={{ textAlign: 'left' }}>
                                    <label style={{ fontWeight: 'bold' }}>{messages['event_name']}<span style={{ color: 'red', fontWeight: 'bold' }}>*</span></label>
                                </div>
                                <div style={{ textAlign: '', display: 'flex', padding: '10px 0px', marginTop: 5 }}>
                                    <div style={{ textAlign: 'left', padding: '8px 0px' }}>
                                        <input type="color" id="head" name="head" value={`${color}`} onChange={e => setColor(e.target.value)} />
                                    </div>
                                    <div style={{ textAlign: 'left', marginLeft: '10px', width: '90%' }}>
                                        <Input
                                            value={name}
                                            onChange={(value) => setName(value)}
                                            maxLength={40}
                                            required
                                            requiredMessage={messages['required_field']}
                                        />


                                    </div>
                                </div>
                                <div style={{ textAlign: 'left' }}>
                                    <Checkbox
                                        id="diagnostic"
                                        label={messages['event_diagnostic']}
                                        value={diagnostic}
                                        onChange={(checked) => setDiagnostic(checked)}
                                    />
                                </div>
                            </Form>
                        </TabContainer>
                        {
                            current?.id &&
                            <TabContainer index={1} label={messages['event_tab_unit_type_event']}>
                                <UnitTypeEventsList event={current} eventId={current?.id} from={"events"} />
                            </TabContainer>
                        }
                    </Tabs>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => {
                        formRefEvent?.current?.submit()
                    }}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default CreateEditEvent;